import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom/client';

// import AntSystemApp from '../AntSystemApp';
import AntUserApp from '../AntUserApp';

export default {
    render: (props) => {
        const rootElement = document.getElementById('root');
        const root = ReactDOM.createRoot(rootElement);

        root.render(
            // <React.StrictMode>
            <React.Fragment>
                {props.appInfo && props.appInfo.isUserApp && (
                    <AntUserApp
                        appNavigation={props.appNavigation}
                        appModules={props.appModules}
                        appInfo={props.appInfo}
                        appRoutes={props.appRoutes}
                        appAssets={props.appAssets}
                        appConfig={props.appConfig}
                        posNavigation={props.posNavigation}
                        posRoutes={props.posRoutes}
                        accountingNavigation={props.accountingNavigation}
                        accountingModules={props.accountingModules}
                        accountingQuickCreate={props.accountingQuickCreate}
                        accountingQuickCreateGroups={props.accountingQuickCreateGroups}
                        backgroundPrinters={props.backgroundPrinters}
                    />
                )}
                {/* {props.appInfo && !props.appInfo.isUserApp && (
                    <AntSystemApp
                        appNavigation={props.appNavigation}
                        appInfo={props.appInfo}
                        appRoutes={props.appRoutes}
                        appAssets={props.appAssets}
                        appConfig={props.appConfig}
                    />
                )} */}
            </React.Fragment>
            // </React.StrictMode>
        );
    }
};
